import { render, staticRenderFns } from "./sectionDelivery.vue?vue&type=template&id=5b78daf0&scoped=true&"
import script from "./sectionDelivery.vue?vue&type=script&lang=js&"
export * from "./sectionDelivery.vue?vue&type=script&lang=js&"
import style0 from "./sectionDelivery.vue?vue&type=style&index=0&id=5b78daf0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b78daf0",
  null
  
)

export default component.exports